import { NgModule } from '@angular/core';
import { NgxDynamicTabindexDirective } from './ngx-dynamic-tabindex.directive';


@NgModule({
  declarations: [NgxDynamicTabindexDirective],
  imports: [],
  exports: [NgxDynamicTabindexDirective]
})
export class NgxDynamicTabindexModule {
}
